import Swiper, {Pagination, Autoplay, Parallax, Navigation } from 'swiper';
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";

const SwiperLib = (()=>{

    const configSwiperHome = ()=>{
        var swiper = new Swiper(".swiper-awards", {
            modules: [Autoplay, Navigation, Pagination],
            slidesPerView: 1,
            spaceBetween: 20,
            navigation: true,
            pagination: {
                el: ".swiper-pagination",
                dynamicBullets: true,
            },
            navigation: {
                nextEl: ".swiper-button-next-custom",
                prevEl: ".swiper-button-prev-custom",
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    spaceBetween: 40,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 50,
                },
                1500: {
                    slidesPerView: 3,
                    spaceBetween: 50,
                },
            }
    
        });
    }

    return {
        setHandleEvent: function(){
            try {configSwiperHome();}catch(err){  }
        }
    }

})();


const loadSwiperHandlers = ()=>{
    SwiperLib.setHandleEvent();
}


export { loadSwiperHandlers }